export default __webpack_public_path__ + "static/media/LogoMaccaferri.5d038d19.png";